import { render, staticRenderFns } from "./template.vue?vue&type=template&id=03c49ad5&scoped=true"
import script from "./template.vue?vue&type=script&lang=js"
export * from "./template.vue?vue&type=script&lang=js"
import style0 from "./template.vue?vue&type=style&index=0&id=03c49ad5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c49ad5",
  null
  
)

export default component.exports